import React from "react";

export default function PrivacyPolicyPage() {
  return (
    <div className="min-vh-100 bg-light py-5 px-4 d-flex flex-column align-items-center">
      <div className="container bg-white shadow-lg rounded-4 p-5 my-4" style={{ maxWidth: "900px" }}>
        <h1 className="display-5 fw-bold mb-4 text-dark border-bottom pb-3">Privacy Policy</h1>

        <p className="text-secondary mb-4 fs-5 fw-medium">
          Last Updated: May 2026
        </p>

        <div className="d-flex flex-column gap-4 text-secondary lh-lg fs-6">
          <section>
            <h2 className="h3 fw-semibold mb-3 text-dark">Introduction</h2>
            <p className="mb-0">
              Field Agent Tracking respects your privacy and is committed to
              protecting your personal information. This Privacy Policy explains
              how we collect, use, and safeguard your data while using our
              application.
            </p>
          </section>

          <section>
            <h2 className="h3 fw-semibold mb-3 text-dark">Information We Collect</h2>
            <ul className="mb-0 ps-4">
              <li className="mb-2">Employee name and contact information</li>
              <li className="mb-2">GPS location data (latitude and longitude)</li>
              <li className="mb-2">Attendance and work activity details</li>
              <li className="mb-2">Device and app usage information</li>
            </ul>
          </section>

          <section>
            <h2 className="h3 fw-semibold mb-3 text-dark">Location Tracking</h2>
            <p className="mb-2">
              Our application collects live location information to provide
              employee tracking, attendance verification, route monitoring, and
              task management functionalities.
            </p>
            <p className="mb-0">
              Background location access may be used during active work sessions
              to ensure accurate field activity monitoring.
            </p>
          </section>

          <section>
            <h2 className="h3 fw-semibold mb-3 text-dark">How We Use Data</h2>
            <ul className="mb-0 ps-4">
              <li className="mb-2">To track field employee activities</li>
              <li className="mb-2">To manage attendance records</li>
              <li className="mb-2">To improve operational efficiency</li>
              <li className="mb-2">To generate reports and analytics</li>
              <li className="mb-2">To improve app performance and security</li>
            </ul>
          </section>

          <section>
            <h2 className="h3 fw-semibold mb-3 text-dark">Data Security</h2>
            <p className="mb-0">
              We implement appropriate technical and organizational measures to
              protect your information against unauthorized access, disclosure,
              or misuse.
            </p>
          </section>

          <section>
            <h2 className="h3 fw-semibold mb-3 text-dark">Third-Party Services</h2>
            <p className="mb-0">
              The application may use third-party services such as maps,
              analytics, and cloud infrastructure providers to improve app
              functionality.
            </p>
          </section>

          <section>
            <h2 className="h3 fw-semibold mb-3 text-dark">Contact Us</h2>
            <p className="mb-2">
              If you have any questions regarding this Privacy Policy, please
              contact us at:
            </p>
            <p className="mb-0 fw-bold text-primary fs-5">ftprovip@gmail.com</p>
          </section>
        </div>
      </div>
    </div>
  );
}
